import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import TextButton from 'components/Luxkit/Button/TextButton'
import Typography from 'components/Luxkit/Typography/Typography'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyLandingPageBenefitsTable from './LoyaltyLandingPageBenefitsTable'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

interface Props {
  /**
   * Highlights the tiers row given (sets a background)
   */
  highlightTier?: App.LoyaltyTier;
  onJoin?: () => void;
}

function LoyaltyLandingPageBenefitsTableSection(props: Props) {
  const { highlightTier, onJoin } = props

  return <Section paletteType="inverse">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={72}>
        <LoyaltyLandingPageBenefitsTable highlightTier={highlightTier} />
        {onJoin && <Typography align="center">
          <TextButton kind="primary" onClick={onJoin}>
            Join now - it's free
          </TextButton>
        </Typography>}
      </Group>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageBenefitsTableSection
